import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { RxAuthService } from '../rx-auth/rx-auth.service';

@Injectable({
  providedIn: 'root',
})
export class VisualizationService {
  private apiUrl = `${environment.backend_base}main/visualizations`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private auth: RxAuthService
  ) {}

  addVisualizationIssue(
    visID: number | null,
    rclID: number | null,
    saqID: number | null,
    cusID: number | null,
    issueFormData: {},
  ): Observable<any> {
    const body = { vis_id: visID, rcl_id: rclID, sqa_id: saqID, custom_id: cusID, form_data: issueFormData };
    return this.http.post<any>(
      `${this.apiUrl}/add_visualization_issue/`,
      body,
      this.auth.httpOptions
    );
  }

  removeVisualizationIssue(
    objID: number,
  ): Observable<any> {
    const body = { obj_id: objID};
    return this.http.post<any>(
      `${this.apiUrl}/remove_visualization_issue/`,
      body,
      this.auth.httpOptions
    );
  }
}
